var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"floating-back-button",attrs:{"href":"#back"},on:{"click":function($event){return _vm.onBackClick($event)}}},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }